export default (route) => {
	return route.name === 'businessCart' || route.name === 'chainListingCart'
}
